function createOverlay(image) {
  const overlay = document.createElement('div');
  overlay.className = 'image-magnify-full-size';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
  overlay.style.backgroundColor = 'var(--gradient-background)';
  image.parentElement.insertBefore(overlay, image);
  return overlay;
}

function moveWithPointer(image, overlay, event, zoomRatio) {
  const imageRect = image.getBoundingClientRect();
  const x = Math.min(Math.max(event.clientX - imageRect.left, 0), imageRect.width);
  const y = Math.min(Math.max(event.clientY - imageRect.top, 0), imageRect.height);
  const xPercent = `${(x / imageRect.width) * 100}%`;
  const yPercent = `${(y / imageRect.height) * 100}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.clientWidth * zoomRatio}px auto`;
}

function enableDesktopHoverZoom(image, zoomRatio) {
  let overlay = null;

  const closeZoom = () => {
    overlay?.remove();
    overlay = null;
  };

  image.addEventListener('mouseenter', (event) => {
    if (overlay) return;

    overlay = createOverlay(image);
    moveWithPointer(image, overlay, event, zoomRatio);
    overlay.addEventListener('mousemove', (moveEvent) => moveWithPointer(image, overlay, moveEvent, zoomRatio));
    overlay.addEventListener('mouseleave', closeZoom);
    overlay.addEventListener('click', closeZoom);
  });
}

function enableTouchLightbox(image) {
  image.addEventListener('click', () => {
    const zoomButton = image.closest('modal-opener')?.querySelector('.product__media-toggle');
    zoomButton?.click();
  });
}

function enableProductZoom(zoomRatio) {
  const supportsPreciseHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    if (image.dataset.kokoZoomReady === 'true') return;
    image.dataset.kokoZoomReady = 'true';

    if (supportsPreciseHover) {
      enableDesktopHoverZoom(image, zoomRatio);
    } else {
      enableTouchLightbox(image);
    }
  });
}

enableProductZoom(2.2);
